// Fase 14A — Selettore lingua accessibile (punti 5, 160-161): etichetta testuale,
// navigabile da tastiera, nomi nativi delle lingue, MAI bandiere.
import { Globe } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function LanguageSelector() {
  const { language, languages, setLanguage, t } = useI18n();
  const current = languages.find((l) => l.code === language);

  const change = async (code) => {
    if (code === language) return;
    try {
      await setLanguage(code);
      toast.success(t("settings.language.saved"),
        { description: languages.find((l) => l.code === code)?.name });
    } catch (e) {
      toast.error(t("common.error"), { description: formatApiError(e) });
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="h-9 gap-1.5"
          data-testid="language-selector-button"
          aria-label={`${t("language.label")}: ${current?.name || language}`}>
          <Globe className="w-4 h-4 text-slate-600" aria-hidden="true" />
          <span className="hidden sm:inline text-sm" data-testid="language-selector-current">
            {current?.name || language}
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44" data-testid="language-selector-menu">
        <DropdownMenuLabel>{t("language.label")}</DropdownMenuLabel>
        {languages.map((l) => (
          <DropdownMenuItem key={l.code} onClick={() => change(l.code)}
            data-testid={`language-option-${l.code}`}
            aria-current={l.code === language ? "true" : undefined}
            className={l.code === language ? "font-semibold text-green-800" : ""}>
            {l.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
